/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import ReactDOM from "react-dom";
import UNSTATED from "unstated-debug";
import * as serviceWorker from "./serviceWorker";
import { I18nextProvider } from "react-i18next";
import { i18nInstance } from "./i18n/i18n";
import { isProduction } from "./utils/globalVar";
import "./styles";
import App from "./App";
import { Route, Router } from "react-router";
import { appState } from "./app-state/store";
import { Provider } from "unstated";

UNSTATED.isCollapsed = false;
if (isProduction) {
  UNSTATED.logStateChanges = false;
}

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};

ReactDOM.render(
  <Provider inject={[appState]}>
    <I18nextProvider i18n={i18nInstance}>
      <Router history={appState.state.appHistory}>
        <Route component={ScrollToTop}>
          <App />
        </Route>
      </Router>
    </I18nextProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
